var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSendMessageSolid = function SvgSendMessageSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h256v256H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M223.444 114.04 54.53 19.446A16 16 0 0 0 31.644 38.79L60.647 120H136a8 8 0 0 1 0 16H60.647l-29.003 81.21a16.04 16.04 0 0 0 15.04 21.41 16.04 16.04 0 0 0 7.846-2.067l168.913-94.592a16.002 16.002 0 0 0 .001-27.922"
  })));
};
export default SvgSendMessageSolid;